"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var CookieConsent = (function (document, window, Bugsnag) {
    var initialized = false;
    var LAST_SUBMITTED_AT_STORAGE_KEY = 'cccLastSubmittedAt';
    var CATEGORIES = {
        necessary: {
            name: 'Necessary',
            description: 'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
        },
        functional: {
            name: 'Functional',
            description: 'Functional cookies help us provide useful site features, remember your preferences, and display relevant content. Approved third parties may set these cookies to provide certain site features. If you do not allow these cookies, then some or all of these services may not function properly.',
        },
        statistic: {
            name: 'Statistic',
            description: 'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
        },
        marketing: {
            name: 'Marketing',
            description: 'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
        }
    };
    var consentState = {
        functional: false,
        statistic: false,
        marketing: false,
        isDefault: true,
    };
    var consentNotice;
    var consentModal;
    var consentModalOverlay;
    var consentCheckboxes = {
        functional: undefined,
        statistic: undefined,
        marketing: undefined,
    };
    var onChangeListeners = [];
    var init = function init() {
        // Return if already initialized.
        if (initialized) {
            return;
        }
        // Update the consent state from the window.
        updateConsentStateFromWindow();
        // Render the cookie banner into the document.
        renderCookieBannerIntoDocument((consentState.isDefault
            && (!consentHasValidLastSubmitted()
                || consentWasLastSubmittedMoreThan30DaysAgo())
            && pageSpecifiesBannerIsEnabled()));
        // Set initialized.
        initialized = true;
    };
    function handleNoticeCustomizeButtonClick(e) {
        showConsentModal(true);
    }
    function handleNoticeDenyAllButtonClick(e) {
        var consentStateKeys = Object.keys(consentState);
        var checkboxKeys = Object.keys(consentCheckboxes);
        // Hide the notice and modal.
        showConsentNotice(false);
        showConsentModal(false);
        // Update the checkboxes to checked.
        checkboxKeys.forEach(function (key) {
            var checkbox = consentCheckboxes[key];
            if (checkbox) {
                checkbox.checked = true;
            }
        });
        // Update the consent state.
        consentStateKeys.forEach(function (key) {
            consentState[key] = false;
        });
        // Persist the consent state.
        persistConsentState();
    }
    function handleNoticeAcceptAllButtonClick(e) {
        var consentStateKeys = Object.keys(consentState);
        var checkboxKeys = Object.keys(consentCheckboxes);
        // Hide the notice and modal.
        showConsentNotice(false);
        showConsentModal(false);
        // Update the checkboxes to checked.
        checkboxKeys.forEach(function (key) {
            var checkbox = consentCheckboxes[key];
            if (checkbox) {
                checkbox.checked = true;
            }
        });
        // Update the consent state.
        consentStateKeys.forEach(function (key) {
            consentState[key] = true;
        });
        // Persist the consent state.
        persistConsentState();
    }
    function handleConsentModalOverlayClick(e) {
        showConsentModal(false);
    }
    function handleConsentModalCancelButtonClick(e) {
        showConsentModal(false);
    }
    function handleConsentModalSaveButtonClick(e) {
        var checkboxKeys = Object.keys(consentCheckboxes);
        // Hide the notice and modal.
        showConsentNotice(false);
        showConsentModal(false);
        // Update the consent state from the checkboxes.
        checkboxKeys.forEach(function (key) {
            var _a;
            consentState[key] = !!((_a = consentCheckboxes[key]) === null || _a === void 0 ? void 0 : _a.checked);
        });
        // Persist the consent state.
        persistConsentState();
    }
    function showConsentNotice(show) {
        if (show === void 0) { show = true; }
        if (consentNotice) {
            if (show) {
                consentNotice.removeAttribute('style');
            }
            else {
                consentNotice.setAttribute('style', 'display: none;');
            }
        }
    }
    function showConsentModal(show) {
        if (show === void 0) { show = true; }
        if (consentModal) {
            if (show) {
                consentModal.removeAttribute('style');
            }
            else {
                consentModal.setAttribute('style', 'display: none;');
            }
        }
    }
    function renderCookieBannerIntoDocument(showNotice) {
        var prefix = 'clubadminpro-ccc';
        var id = function (i) { return prefix + '-' + i; };
        var cls = function (i) { return prefix + '-' + i; };
        var categoryKeys = Object.keys(CATEGORIES);
        var ccc = div({
            id: prefix,
            children: [
                div({
                    id: id('notice'),
                    el: function (el) { return consentNotice = el; },
                    style: showNotice
                        ? undefined
                        : 'display: none;',
                    children: [
                        div(id('notice-panel'), [
                            div(id('notice-panel-content'), [
                                createElement('h2', {
                                    id: id('notice-panel-content-title'),
                                    children: [
                                        text('Select your cookie preferences')
                                    ]
                                }),
                                div(id('notice-panel-content-actions'), [
                                    createElement('p', {
                                        id: id('notice-panel-content-actions-text'),
                                        children: [
                                            text('We use cookies and similar tools to enhance your experience, provide our services, deliver relevant advertising, and make improvements. Approved third parties also use these tools to help us deliver advertising and provide certain site features.')
                                        ]
                                    }),
                                    div(id('notice-panel-content-actions-buttons'), [
                                        button({
                                            id: id('notice-panel-content-actions-buttons-customize-button'),
                                            class: cls('notice-panel-content-actions-button'),
                                            children: [
                                                text('Customize')
                                            ],
                                            eventListeners: [
                                                { event: 'click', handler: handleNoticeCustomizeButtonClick }
                                            ]
                                        }),
                                        button({
                                            id: id('notice-panel-content-actions-buttons-accept-all-button'),
                                            class: cls('notice-panel-content-actions-button'),
                                            children: [
                                                text('Accept all')
                                            ],
                                            eventListeners: [
                                                { event: 'click', handler: handleNoticeAcceptAllButtonClick }
                                            ]
                                        }),
                                        button({
                                            id: id('notice-panel-content-actions-buttons-deny-all-button'),
                                            class: cls('notice-panel-content-actions-button'),
                                            children: [
                                                text('Deny all')
                                            ],
                                            eventListeners: [
                                                { event: 'click', handler: handleNoticeDenyAllButtonClick }
                                            ]
                                        })
                                    ])
                                ])
                            ])
                        ])
                    ]
                }),
                div({
                    id: id('consent-modal'),
                    style: 'display: none;',
                    el: function (el) { return consentModal = el; },
                    children: [
                        div({
                            id: id('consent-modal-panel'),
                            'data-id': 'tab-trap',
                            children: [
                                div(id('consent-modal-panel-inner'), [
                                    div(id('consent-modal-panel-content'), [
                                        div(id('consent-modal-panel-content-header'), [
                                            div(id('consent-modal-panel-content-title'), [
                                                createElement('h2', {
                                                    children: [
                                                        text('Customize cookie preferences')
                                                    ]
                                                })
                                            ])
                                        ]),
                                        div(id('consent-modal-panel-content-body'), __spreadArray(__spreadArray([
                                            div({
                                                class: cls('consent-modal-panel-content-body-info-container'),
                                                children: [text('We use cookies and similar tools (collectively, "cookies") for the following purposes.')]
                                            })
                                        ], categoryKeys.map(function (categoryKey) {
                                            var category = CATEGORIES[categoryKey];
                                            return div({
                                                class: cls('consent-modal-panel-content-body-cookie-consent-container'),
                                                children: [
                                                    createElement('h3', {
                                                        class: cls('consent-modal-panel-content-body-cookie-consent-container-title'),
                                                        children: [text(category.name)]
                                                    }),
                                                    div({
                                                        class: cls('consent-modal-panel-content-body-cookie-consent-container-text'),
                                                        children: [
                                                            createElement('p', {
                                                                class: cls('consent-modal-panel-content-body-cookie-consent-container-paragraph'),
                                                                children: [text(category.description)]
                                                            })
                                                        ]
                                                    }),
                                                    div({
                                                        class: cls('consent-modal-panel-content-body-cookie-consent-container-action'),
                                                        children: categoryKey === 'necessary'
                                                            ? undefined
                                                            : [
                                                                createElement('label', {
                                                                    style: 'margin-left: 1rem',
                                                                    children: [
                                                                        createElement('input', {
                                                                            type: 'checkbox',
                                                                            style: 'margin-right: 0.25rem',
                                                                            el: function (el) { return consentCheckboxes[categoryKey] = el; }
                                                                        }),
                                                                        text('Allowed')
                                                                    ]
                                                                })
                                                            ]
                                                    })
                                                ]
                                            });
                                        }), true), [
                                            div({
                                                class: cls('consent-modal-panel-content-body-disclaimer-container'),
                                                children: [
                                                    text('Blocking some types of cookies may impact your experience of our sites. You may review and change your choices at any time by clicking Cookie preferences in the footer of this site. We and selected third-parties use cookies or similar technologies as specified on our '),
                                                    createElement('a', {
                                                        href: route('cookies'),
                                                        children: [text('Cookies Page')]
                                                    }),
                                                    text('.')
                                                ]
                                            })
                                        ], false)),
                                        div(id('consent-modal-panel-content-footer'), [
                                            button({
                                                id: id('cookie-preferences-cancel-button'),
                                                class: "".concat(cls('consent-modal-panel-content-footer-button'), " ").concat(cls('consent-modal-panel-content-footer-button__cancel')),
                                                children: [text('Cancel')],
                                                eventListeners: [{ event: 'click', handler: handleConsentModalCancelButtonClick }]
                                            }),
                                            button({
                                                id: id('cookie-preferences-cancel-button'),
                                                class: "".concat(cls('consent-modal-panel-content-footer-button'), " ").concat(cls('consent-modal-panel-content-footer-button__save')),
                                                children: [text('Save preferences')],
                                                eventListeners: [{ event: 'click', handler: handleConsentModalSaveButtonClick }]
                                            })
                                        ])
                                    ])
                                ])
                            ]
                        }),
                        div({
                            id: id('consent-modal-overlay'),
                            el: function (el) { return consentModalOverlay = el; },
                            eventListeners: [
                                { event: 'click', handler: handleConsentModalOverlayClick }
                            ]
                        }),
                        div({
                            id: id('tabtrap'),
                            'data-id': 'tab-trap'
                        })
                    ]
                })
            ]
        });
        if (document.body.firstChild) {
            document.body.insertBefore(ccc, document.body.firstChild);
        }
        else {
            document.body.appendChild(ccc);
        }
    }
    function consentHasValidLastSubmitted() {
        var lastSubmitted = window.localStorage.getItem(LAST_SUBMITTED_AT_STORAGE_KEY);
        if (!lastSubmitted) {
            return false;
        }
        return isValidDate(new Date(parseInt(lastSubmitted, 10)));
    }
    function consentWasLastSubmittedMoreThan30DaysAgo() {
        var offset = (24 * 60 * 60 * 1000) * 30; // 30 days
        var today = new Date();
        var thirtyDaysAgo = new Date();
        thirtyDaysAgo.setTime(today.getTime() - offset);
        var lastSubmittedTimestamp = window.localStorage.getItem(LAST_SUBMITTED_AT_STORAGE_KEY);
        if (!lastSubmittedTimestamp) {
            return false;
        }
        var lastSubmitted = new Date(parseInt(lastSubmittedTimestamp, 10));
        if (!isValidDate(lastSubmitted)) {
            return false;
        }
        return lastSubmitted < thirtyDaysAgo;
    }
    function setConsentLastSubmittedAtNow() {
        window.localStorage.setItem(LAST_SUBMITTED_AT_STORAGE_KEY, '' + (new Date()).getTime());
    }
    function persistConsentState() {
        try {
            // Get some initial variables.
            var submittedFrom = window.location.href.substring(0, 255);
            // Set the consent last submitted at.
            setConsentLastSubmittedAtNow();
            // Make the HTTP request.
            axios.post(route('api-ccc.cookie-consent'), {
                functional: consentState.functional,
                statistic: consentState.statistic,
                marketing: consentState.marketing,
                submitted_from: submittedFrom,
            }, {
                withCredentials: true
            }).then(function (response) {
                // Fire change listeners.
                onChangeListeners.forEach(function (listener) {
                    listener(consentState);
                });
            }).catch(function (err) {
                Bugsnag.notify(err);
            });
        }
        catch (e) {
            if (e instanceof Error) {
                Bugsnag.notify(e);
            }
            else {
                Bugsnag.notify('Error !instanceof Error', function (event) {
                    event.addMetadata('error', {
                        error: e
                    });
                });
            }
        }
    }
    function updateConsentStateFromWindow() {
        if (!window
            || !window.clubadminpro_page_data
            || !window.clubadminpro_page_data.ccc
            || typeof window.clubadminpro_page_data.ccc !== 'object'
            || window.clubadminpro_page_data.ccc === null) {
            Bugsnag.notify('Page does not have ccc');
            return;
        }
        var missingCCCKeys = [];
        // Update the consent state.
        if (window.clubadminpro_page_data.ccc.hasOwnProperty('functional')) {
            consentState.functional = !!window.clubadminpro_page_data.ccc.functional;
        }
        else {
            missingCCCKeys.push('functional');
        }
        if (window.clubadminpro_page_data.ccc.hasOwnProperty('statistic')) {
            consentState.statistic = !!window.clubadminpro_page_data.ccc.statistic;
        }
        else {
            missingCCCKeys.push('statistic');
        }
        if (window.clubadminpro_page_data.ccc.hasOwnProperty('marketing')) {
            consentState.marketing = !!window.clubadminpro_page_data.ccc.marketing;
        }
        else {
            missingCCCKeys.push('marketing');
        }
        if (window.clubadminpro_page_data.ccc.hasOwnProperty('is_default')) {
            consentState.isDefault = !!window.clubadminpro_page_data.ccc.is_default;
        }
        else {
            missingCCCKeys.push('is_default');
        }
        // Notify bugsnag if any values were missing.
        if (missingCCCKeys.length > 0) {
            Bugsnag.notify('Invalid ccc page data', function (event) {
                event.addMetadata('pageData', {
                    data: (window.clubadminpro_page_data
                        && window.clubadminpro_page_data.ccc) ? window.clubadminpro_page_data.ccc : undefined,
                    missing: missingCCCKeys
                });
            });
        }
    }
    function pageSpecifiesBannerIsEnabled() {
        if (!window || !window.clubadminpro_page_data) {
            Bugsnag.notify('Page does not have clubadminpro_page_data');
            return true;
        }
        else if (window.clubadminpro_page_data.ccc_show_banner === false) {
            return false;
        }
        return true;
    }
    function div(idOrChildrenOrOptions, optsOrChildren) {
        return createElement('div', idOrChildrenOrOptions, optsOrChildren);
    }
    function button(idOrChildrenOrOptions, optsOrChildren) {
        return createElement('button', idOrChildrenOrOptions, optsOrChildren);
    }
    function text(text) {
        return document.createTextNode(text);
    }
    function createElement(tagName, idOrChildrenOrOptions, optsOrChildren) {
        var el = document.createElement(tagName);
        var options;
        if (isString(idOrChildrenOrOptions)) {
            options = __assign(__assign({}, (isPlainObject(optsOrChildren)
                ? optsOrChildren
                : { children: Array.isArray(optsOrChildren) ? optsOrChildren : [] })), { id: idOrChildrenOrOptions });
        }
        else if (Array.isArray(idOrChildrenOrOptions)) {
            options = {
                children: idOrChildrenOrOptions
            };
        }
        else {
            options = idOrChildrenOrOptions;
        }
        if (options.id) {
            el.setAttribute('id', options.id);
        }
        if (options.class) {
            el.setAttribute('class', options.class);
        }
        if (options.style) {
            el.setAttribute('style', options.style);
        }
        if (tagName === 'input' && options.type) {
            el.setAttribute('type', options.type);
        }
        if (tagName === 'a' && options.href) {
            el.setAttribute('href', options.href);
        }
        if (options['data-id']) {
            el.setAttribute('data-id', options['data-id']);
        }
        if (tagName === 'input' && options.checked) {
            el.checked = options.checked;
        }
        if (options.children) {
            for (var i = 0, il = options.children.length; i < il; i++) {
                if (options.children[i] === null || typeof options.children[i] === 'undefined') {
                    continue;
                }
                el.appendChild(options.children[i]);
            }
        }
        if (options.eventListeners) {
            for (var j = 0, jl = options.eventListeners.length; j < jl; j++) {
                el.addEventListener(options.eventListeners[j].event, options.eventListeners[j].handler);
            }
        }
        if (options.el) {
            options.el(el);
        }
        return el;
    }
    function isNil(value) {
        return value == null;
    }
    function getTag(value) {
        if (value == null) {
            return value === undefined ? '[object Undefined]' : '[object Null]';
        }
        return Object.prototype.toString.call(value);
    }
    function isNumber(value) {
        return typeof value === 'number'
            || (isObjectLike(value) && getTag(value) == '[object Number]');
    }
    function isFinite(value) {
        return isNumber(value) && window.isFinite(value);
    }
    function isString(value) {
        var type = typeof value;
        return type === 'string' || (type === 'object' && value != null && !Array.isArray(value) && getTag(value) == '[object String]');
    }
    function isBoolean(value) {
        return value === true || value === false ||
            (isObjectLike(value) && getTag(value) == '[object Boolean]');
    }
    function isObjectLike(value) {
        return typeof value === 'object' && value !== null;
    }
    function isPlainObject(value) {
        if (!isObjectLike(value) || getTag(value) != '[object Object]') {
            return false;
        }
        if (Object.getPrototypeOf(value) === null) {
            return true;
        }
        var proto = value;
        while (Object.getPrototypeOf(proto) !== null) {
            proto = Object.getPrototypeOf(proto);
        }
        return Object.getPrototypeOf(value) === proto;
    }
    function isValidDate(date) {
        return date.getTime() > 0;
    }
    function parseJsonStringToObject(jsonString) {
        try {
            var o = JSON.parse(jsonString);
            // Handle non-exception-throwing cases:
            // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
            // but... JSON.parse(null) returns null, and typeof null === "object",
            // so we must check for that, too.
            if (isPlainObject(o)) {
                return o;
            }
        }
        catch (e) { }
        return false;
    }
    return {
        init: init,
        showConsentNotice: showConsentNotice,
        showConsentModal: showConsentModal,
        allowsCategory: function (category) {
            if (category === 'necessary') {
                return true;
            }
            return consentState[category];
        },
        onChange: function (callback) {
            if (callback) {
                onChangeListeners.push(callback);
            }
        }
    };
})(document, window, Bugsnag);
module.exports = CookieConsent;
